"use client";

import React from "react";

import { useAppAvailability } from "@/hooks/use-app-availability";

// Wrappers so a server-rendered page can gate whole sections on how the app is
// actually installable, without turning the page itself into a client component.
// While the manifest is loading none of them show, which keeps the page from
// flashing "not published yet" at someone whose download is about to appear.

export function WhenAppPublished({ children }: { children: React.ReactNode }) {
  const { route } = useAppAvailability();
  return route === "play" || route === "apk" ? <>{children}</> : null;
}

// The sideload instructions only make sense for a direct .apk; installing from
// Play needs none of them.
export function WhenApkDownload({ children }: { children: React.ReactNode }) {
  return useAppAvailability().route === "apk" ? <>{children}</> : null;
}

export function WhenPlayStore({ children }: { children: React.ReactNode }) {
  return useAppAvailability().route === "play" ? <>{children}</> : null;
}

export function WhenAppUnavailable({ children }: { children: React.ReactNode }) {
  return useAppAvailability().route === "none" ? <>{children}</> : null;
}
